export default __webpack_public_path__ + "static/Penske-446b42fdc60c5655e1ec6a429c3ac258.svg";